import React, { useState, useEffect, useMemo, useCallback } from 'react';
import Select from "react-select";
import { findObjInArr } from "@app/utils/CommonFunctions";
import * as mainService from '@app/services/mainService';

const PhanloaisukienListComponent = ({
                                         onChange,
                                         phanloaisukien_fk,
                                         tableName,
                                         id_tableName,
                                         path_access,
                                         nhomsukien_fk,
                                         coquan_fk,
                                         required = false
                                     }) => {
    const [listPhanloaisukiens, setListPhanloaisukiens] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    // Memoize the API parameters to prevent unnecessary re-fetches
    const apiParams = useMemo(() => ({
        path_access,
        tableName,
        id_tableName,
        coquan_fk,
        nhomsukien_fk
    }), [path_access, tableName, id_tableName, coquan_fk, nhomsukien_fk]);

    useEffect(() => {
        const fetchPhanloaisukiens = async () => {


            setIsLoading(true);
            setError(null);

            try {
                const response = await mainService.getAllPhanloaisukien(apiParams);
                setListPhanloaisukiens(response || []);
            } catch (error) {
                console.error('Error fetching phanloaisukiens:', error);
                setError(error.message || 'Failed to fetch data');
                setListPhanloaisukiens([]);
            } finally {
                setIsLoading(false);
            }
        };

        fetchPhanloaisukiens();
    }, [apiParams]);

    // Memoize the selected value to prevent unnecessary recalculations
    const selectedValue = useMemo(() => {
        if (!phanloaisukien_fk || !listPhanloaisukiens.length) {
            return null;
        }
        return findObjInArr(listPhanloaisukiens, phanloaisukien_fk);
    }, [listPhanloaisukiens, phanloaisukien_fk]);

    // Memoize the onChange handler to prevent unnecessary re-renders
    const handleChange = useCallback((selectedOption) => {
        onChange?.(selectedOption);
    }, [onChange]);

    // Show error state
    if (error) {
        return (
            <div>
                <label>Phân loại sự kiện</label>
                <div className="error-message" style={{ color: 'red', fontSize: '0.875rem' }}>
                    Error: {error}
                </div>
            </div>
        );
    }

    return (
        <div>
            <label className={required ? "required" : ""} htmlFor="phanloaisukien_select">Phân loại sự kiện</label>
            <Select
                inputId="phanloaisukien_select"
                isClearable
                isLoading={isLoading}
                isDisabled={isLoading}
                name="phanloaisukien_fk"
                onChange={handleChange}
                value={selectedValue}
                options={listPhanloaisukiens}
                placeholder={isLoading ? "Đang tải..." : "Chọn phân loại sự kiện"}
                noOptionsMessage={() => "Không có dữ liệu"}
                loadingMessage={() => "Đang tải..."}
            />
        </div>
    );
};

export default React.memo(PhanloaisukienListComponent);